import { render, staticRenderFns } from "./wtransfer.vue?vue&type=template&id=09ee8028"
import script from "./wtransfer.vue?vue&type=script&lang=js"
export * from "./wtransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports